function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import find from 'lodash/find';
import Input from 'components/Form/Input';
var _React_PureComponent;
class UniformChoice extends (_React_PureComponent = React.PureComponent) {
    onChange(input) {
        if (!this.props.isMultiple) {
            return this.props.onChange({
                id: this.props.id,
                value: input.value
            });
        }
        let value = this.props.value ? this.props.value : [];
        if (input.value) {
            value = [
                ...value,
                input.value
            ];
        } else {
            value = value.filter((v)=>v !== this.props.inputValue);
        }
        return this.props.onChange({
            id: this.props.id,
            value
        });
    }
    get isMultiple() {
        return this.props.isMultiple && !this.props.isRadio;
    }
    get value() {
        if (!this.isMultiple) {
            return this.props.value;
        }
        return find(this.props.value, (i)=>i === this.props.inputValue.toString());
    }
    get isChecked() {
        return this.value === this.props.inputValue;
    }
    render() {
        const id = `${this.props.id}-${this.props.inputValue}`;
        const attributes = _object_spread_props(_object_spread({}, this.props.attributes), {
            checked: this.isChecked
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: cn({
                'uniform-checker': !this.props.isRadio,
                'uniform-choice': this.props.isRadio,
                disabled: this.props.isDisabled
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn('form-input__hover', {
                        disabled: this.props.isDisabled
                    })
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: cn({
                        checked: this.isChecked
                    }),
                    children: /*#__PURE__*/ _jsx(Input, {
                        id: id,
                        type: this.props.isRadio ? 'radio' : 'checkbox',
                        value: this.props.inputValue,
                        formControl: false,
                        attributes: attributes,
                        onChange: (input)=>this.onChange(input),
                        onBlur: this.props.onBlur,
                        isDisabled: this.props.isDisabled
                    })
                })
            ]
        });
    }
}
_define_property(UniformChoice, "propTypes", {
    // Explicit props
    id: PropTypes.string.isRequired,
    inputValue: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    attributes: PropTypes.object,
    isDisabled: PropTypes.bool,
    isMultiple: PropTypes.bool,
    isRadio: PropTypes.bool,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
});
_define_property(UniformChoice, "defaultProps", {
    value: '',
    attributes: {},
    isDisabled: false,
    isMultiple: false,
    isRadio: false,
    onBlur: ()=>{}
});
export default UniformChoice;
